import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import About from "@/components/About";
import NextPageCta from "@/components/NextPageCta";

export default function AboutPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="About"
        title="Qualified handyman."
        italic="Local roots."
        blurb="An independent trade, built around one principle: hand back every property better than you found it."
      />
      <About />
      <NextPageCta to="/about/my-story" label="Read my story →" sub="From Manchester to London to Warwickshire — the road that led here." />
    </Layout>
  );
}
